import { serializeSelectedSet } from "./core.js";

/**
 * A FilterControl plugs into the calendar core's filter pipeline.
 *
 * {
 *   key,               // unique id; also the URL param key unless paramKey is set
 *   paramKey,          // optional; false => never serialized to a URL param
 *   predicate,         // optional (event) => bool; filterEvents ANDs all predicates
 *   serialize,         // optional () => string|null; control owns "omit if all selected"
 *   serializeForIcal,  // optional; false => excluded from the iCal URL
 *   getState,          // optional () => any; readable via controller.getFilterState(key)
 *   init,              // optional (ctx) => void; ctx.controller, ctx.triggerChange()
 * }
 */

/**
 * Built-in calendar toggle-button control (#calendar-filters, colored toggles).
 *
 * NOTE: this control intentionally has no event predicate. Calendar visibility
 * reaches events only through a project's category->calendar mapping (see the
 * category control in index.js); here the calendar selection is purely a state
 * provider + URL param.
 */
export function createCalendarToggleControl(el, opts) {
  opts = opts || {};
  var containerId = opts.containerId || "calendar-filters";
  var container = document.getElementById(containerId);

  var activeCalendars = new Set();
  var allCalendarIds = new Set();

  if (container) {
    container
      .querySelectorAll("[data-calendar-toggle]")
      .forEach(function (wrapper) {
        var calId = wrapper.getAttribute("data-calendar-toggle");
        var checkbox = wrapper.querySelector("input[type='checkbox']");
        allCalendarIds.add(calId);
        if (checkbox && checkbox.checked) {
          activeCalendars.add(calId);
        }
      });
  }

  return {
    key: "calendars",
    getState: function () {
      return { active: activeCalendars, all: allCalendarIds };
    },
    serialize: function () {
      return serializeSelectedSet(activeCalendars, allCalendarIds);
    },
    init: function (ctx) {
      if (!container) return;
      container.addEventListener("change", function (e) {
        var checkbox = e.target;
        if (checkbox.type !== "checkbox") return;
        var wrapper = checkbox.closest("[data-calendar-toggle]");
        if (!wrapper) return;
        var calId = wrapper.getAttribute("data-calendar-toggle");
        if (checkbox.checked) {
          activeCalendars.add(calId);
        } else {
          activeCalendars.delete(calId);
        }
        ctx.triggerChange("calendars");
      });
    },
  };
}
